import type { CompanyFilters } from "../../types";
import {
  defaultFinancingEventsSlice,
  type FinancingEventsSlice,
} from "./slice";

export function toCompanyFilters(
  slice: FinancingEventsSlice
): Partial<CompanyFilters> {
  if (!slice.inclusionMethod) return {};

  return {
    hasFinancingEvent: {
      inclusionMethod: slice.inclusionMethod,
      ...(slice.discoveredWithinDays && {
        discoveredWithinDays: slice.discoveredWithinDays,
      }),
      ...(slice.financingTypes.length > 0 && {
        financingTypes: slice.financingTypes,
      }),
      ...(slice.minAmount != null && { minAmount: slice.minAmount }),
    },
  };
}

export function fromCompanyFilters(
  filters: CompanyFilters
): FinancingEventsSlice {
  const filter = filters.hasFinancingEvent;
  if (!filter?.inclusionMethod) return defaultFinancingEventsSlice;

  return {
    inclusionMethod: filter.inclusionMethod,
    discoveredWithinDays: filter.discoveredWithinDays ?? null,
    financingTypes: filter.financingTypes ?? [],
    minAmount: filter.minAmount ?? null,
  };
}
